import { auth } from "auth"
import { Menu } from "materia"
import { useTranslation } from "react-i18next"
import { useOptimizedCompanyLogo } from "../../../../tools/useOptimizedCompanyLogo"
import s from "./styles.module.scss"

type DropdownCompanyProps = {
  companies: {
    companyName: string
    companyLogo: string
    href: string
  }[]
  logoUrl: string
  name: string | null
}
export const DropdownCompany = ({
  companies,
  logoUrl,
  name,
}: DropdownCompanyProps) => {
  const { t } = useTranslation()
  const { optimizeLogo } = useOptimizedCompanyLogo()

  return (
    <Menu>
      <Menu.Trigger dataTestId="dropdown-company-trigger">
        <div className={s.company}>
          <img
            className={s.company__thumbnail}
            src={optimizeLogo(logoUrl)}
            alt=""
          />
          <div className={s.company__name}>{name}</div>
        </div>
      </Menu.Trigger>

      <Menu.Content>
        {companies.map(({ companyName, companyLogo, href }) => (
          <Menu.Item as="a" key={companyName} title={companyName} href={href}>
            <img
              className={s.company__logo}
              src={optimizeLogo(companyLogo)}
              alt=""
            />
          </Menu.Item>
        ))}

        <Menu.Item>
          <button
            className={s.company__addCompanyButton}
            onClick={() => auth.loginNewSession()}
          >
            {t("sessions.ADD_SESSION")}
          </button>
        </Menu.Item>
      </Menu.Content>
    </Menu>
  )
}
